import module from 'cheques/module.js'
import { orderBy } from 'lodash'

const schema = {}

class ChequesEmpresasService {
  constructor ($http) {
    this.$http = $http
  }

  get () {
    return this.$http.get('/api2/empresas', {
        schema,
      })
      .then((response) => {
        let data = response.data
          .filter((item) => item.cuentas > 0)
          .map((item) => ({
            CuentasBancarias: item.cuentas,
            ID_Cliente: item.kardex_id_empleado,
            Nombre: item.nombre,
            RFC: item.rfc,
          }))

        response.data = orderBy(data, ['Nombre'])

        return response
      })
  }
}

module.service('ChequesEmpresas', ChequesEmpresasService)




// WEBPACK FOOTER //
// ./src/cheques/services/ChequesEmpresas.js